import { create } from "zustand";

type SessionExpiredNoticeStore = {
  isVisible: boolean;
  show: () => void;
  hide: () => void;
};

/** Whether the session-expired notice is up, so the other floating notices yield to it. */
export const useSessionExpiredNoticeStore = create<SessionExpiredNoticeStore>((set) => ({
  isVisible: false,
  show: () => set({ isVisible: true }),
  hide: () => set({ isVisible: false }),
}));
